import {
  IAdvanceSearchFilter,
  IGroupInfoMembers,
  UserDirectoryFilterType,
} from "@home-health-notify/domain";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import Tab from "@mui/material/Tab";
import { UserDirectoryContext } from "hhn-commons";
import * as React from "react";
import { useContext } from "react";
import TabPanel from "../common/tabs/TabPanel";
import AddGroupList from "./addGroups/AddGroupList";
import {
  AddMemberTabs,
  AddMemberTabsContainer,
  AddUserListContainer,
} from "./AddMember.style";
import AddMemberChips from "./addUsers/AddMemberChips";
import AddUserList from "./addUsers/AddUserList";
import { IPatientHeaderProps } from "./addUsers/advanceSearch/AdvanceSearchHelper";

function a11yProps(index: number) {
  return {
    id: `add-member-tab-${index}`,
    "aria-controls": `add-member-tab-panel-${index}`,
  };
}

export type AddMemberType = {
  existingGroup?: boolean;
  buttonLabel?: string;
  existingMember?: IGroupInfoMembers[];
  callback: (selectedMembers: any) => void;
  isLoading: boolean;
  hideGroupsTab?: boolean;
  minMembers?: number;
  enableReferrals?: boolean;
  userDirectoryFilters?: Partial<UserDirectoryFilterType>;
  advanceSearchFilters?: IAdvanceSearchFilter | undefined;
  hideSearchAndFilters?: boolean;
  patientHeaderProps?: IPatientHeaderProps | undefined;
};
const AddMember = ({
  existingGroup = false,
  buttonLabel,
  existingMember,
  callback,
  isLoading,
  hideGroupsTab = false,
  minMembers,
  enableReferrals = false,
  userDirectoryFilters,
  advanceSearchFilters,
  hideSearchAndFilters = false,
  patientHeaderProps,
}: AddMemberType) => {
  const { userDirectory } = useContext(UserDirectoryContext);

  const allTabs = [
    {
      index: 0,
      label: "Users",
      icon: <PersonIcon />,
    },
    {
      index: 1,
      label: "Groups",
      icon: <GroupsIcon />,
    },
  ];
  const [value, setValue] = React.useState(0);

  const userDirectoryData =
    userDirectory.getFilteredActiveUserDirectory(userDirectoryFilters);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <AddUserListContainer>
      {!hideGroupsTab && (
        <AddMemberTabs
          value={value}
          onChange={handleChange}
          aria-label="tabs in add member panel"
          variant="fullWidth"
        >
          {allTabs.map(tab => (
            <Tab
              key={"add-member-tab" + tab.index}
              label={tab.label}
              value={tab.index}
              icon={tab.icon}
              iconPosition="start"
              data-testid={"add-member-tab-" + tab.index}
              {...a11yProps(tab.index)}
            />
          ))}
        </AddMemberTabs>
      )}
      <AddMemberTabsContainer>
        <TabPanel value={value} index={0} uniqueKey="add-members">
          <AddUserList
            existingGroup={existingGroup}
            existingMembers={existingMember}
            tabValue={value}
            enableReferrals={enableReferrals}
            advanceSearchFilters={advanceSearchFilters}
            users={userDirectoryData}
            hideSearchAndFilters={hideSearchAndFilters}
            patientHeaderProps={patientHeaderProps}
            onAddMemberCallback={callback}
          />
        </TabPanel>
        {!hideGroupsTab && (
          <TabPanel value={value} index={1} uniqueKey="add-members">
            <AddGroupList tabValue={value} />
          </TabPanel>
        )}
      </AddMemberTabsContainer>
      <AddMemberChips
        buttonLabel={buttonLabel}
        isLoading={isLoading}
        minMembers={minMembers}
        onAddMemberCallback={callback}
      />
    </AddUserListContainer>
  );
};

export default AddMember;
